/**
 * 이미지 요소의 이미지 로드 여부 프로미스를 반환하는 함수
 */
export function loadImgElement({
  element,
  src,
}: {
  element: HTMLImageElement;
  src: string;
}) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    element.onload = () => {
      element.onload = null;
      element.onerror = null;
      resolve(element);
    };
    element.onerror = error => {
      element.onload = null;
      element.onerror = null;
      reject({error, element});
    };
    element.src = src;
  });
}
